import { useEffect } from 'react';
import usePostHogCapture from 'src/hooks/posthog/usePostHogCapture';

export default function useCaptureSurveyShownEvent(surveyId: string) {
	const { captureEvent } = usePostHogCapture();

	useEffect(() => {
		captureEvent('survey shown', { $survey_id: surveyId });
	}, [captureEvent, surveyId]);
}
